export default __webpack_public_path__ + "static/media/our-team-member-06.c63d6a30.jpg";